/*
 * Event-bus.ts
 * Description: Includes the declaration
 * for using an event bus
 */

import Vue from 'vue';
export const EventBus = new Vue();
